'use client'

import { HTMLAttributes } from 'react'
import clsx from 'clsx'

import { getTimeFromDate, parseDateToDDMMYYYY } from 'shared/utils/date'

import { SaleOrder } from '../../../types'

import EditSaleOrderButton from './EditSaleOrderButton'

import styles from './EditSaleOrderLabel.module.scss'

interface EditSaleOrderLabelProps extends HTMLAttributes<HTMLDivElement> {
  currentOrder: SaleOrder
}

const EditSaleOrderLabel = ({
  currentOrder,
  className,
  ...props
}: EditSaleOrderLabelProps) => {
  return (
    <div className={clsx(styles.wrapper, className)} {...props}>
      <div className={styles.text}>
        Edycja zamówienia z obecnym terminem dostawy jest możliwa do:{' '}
        <strong>
          {parseDateToDDMMYYYY(currentOrder.editableUntil)}{' '}
          {getTimeFromDate(currentOrder.editableUntil)}
        </strong>
        .<br />
        Pamiętaj aby ją zatwierdzić przed upływem tego terminu.
      </div>
      <EditSaleOrderButton size='large' order={currentOrder} />
    </div>
  )
}

export default EditSaleOrderLabel
